import React from "react";
import { getPrizeAccentColor, PRIZE_LINE_PATH } from "../../Data/prizeAccents";

const PrizeLine = ({ accent, mirror = false }) => (
  <svg
    className={`prizes__currency-line${mirror ? " prizes__currency-line--mirror" : ""}`}
    width="29"
    height="2"
    viewBox="0 0 30 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d={PRIZE_LINE_PATH} fill={getPrizeAccentColor(accent)} />
  </svg>
);

export default PrizeLine;
